import { disableScroll } from './disable-scroll.js';
import { enableScroll } from './enable-scroll.js';

const COOKIE_NAME = 'karamel_age_verified';
const COOKIE_DAYS = 365;

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

function hideAgeGate(ageGate) {
    ageGate.setAttribute('hidden', '');
    enableScroll();
}

function denyAccess() {
    window.close();

    window.setTimeout(() => {
        window.location.href = 'about:blank';
    }, 100);
}

function initAgeGate() {
    const ageGate = document.querySelector('[data-age-gate]');

    if (!ageGate) {
        return;
    }

    if (getCookie(COOKIE_NAME) === '1') {
        ageGate.remove();
        return;
    }

    const confirmBtn = ageGate.querySelector('[data-age-gate-confirm]');
    const denyBtn = ageGate.querySelector('[data-age-gate-deny]');

    ageGate.removeAttribute('hidden');
    disableScroll();

    confirmBtn?.addEventListener('click', () => {
        setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
        hideAgeGate(ageGate);
    });

    denyBtn?.addEventListener('click', denyAccess);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !ageGate.hasAttribute('hidden')) {
            event.preventDefault();
        }
    });
}

document.addEventListener('DOMContentLoaded', initAgeGate);
